export const colorOptions = [
  { value: '#ffffff', label: 'White' },
  { value: '#f8d7da', label: 'Light Red' },
  { value: '#d4edda', label: 'Light Green' },
  { value: '#cce5ff', label: 'Light Blue' },
  { value: '#fff3cd', label: 'Light Yellow' },
  { value: '#e2e3e5', label: 'Light Gray' },
  { value: '#d7f2e3', label: 'Mint' },
  { value: '#e8d4f4', label: 'Lavender' },
  { value: '#ffdab9', label: 'Peach' },
]; 